import React from 'react';
import useLanguage from '../../../../hooks/useLanguage';
// import PropTypes from 'prop-types';

const HomePackages = () => {
  return (
    <section className="home-packages" data-scroll-section>
      <div className="content-wrapper">
        <div className="home-packages__header">
          <div className="home-about__header-info">
            <span className="home-about__header-info__marker">
              {useLanguage('Пакети уроків', 'Пакеты уроков')}
            </span>
            <h2 className="home-about__header-info__title">
              {useLanguage(
                'Онлайн уроки англійської мови',
                'Онлайн укроки английского языка'
              )}
            </h2>
            {/* <span className="info-title__allert">
              {useLanguage(
                'Ціни на уроки актуальні до ',
                'Цены на уроки актуальны до '
              )}
              <span className="info-title__allert--date">
                {useLanguage('01.09.2022 !', '01.09.2022 !')}
              </span>
            </span> */}
          </div>
        </div>
      </div>
    </section>
  );
};

// HomePackages.propTypes = {};

export default HomePackages;
